import { FamilyMember } from 'mcsclient/models';
import { ApiCallResultStatus } from 'store/apiCallResultStatus';

export interface IFamilyState {
  getFamilyMembersStatus: ApiCallResultStatus;
  familyMembers?: FamilyMember[];
}

export function getDefaultFamilyState(): IFamilyState {
  return {
    getFamilyMembersStatus: ApiCallResultStatus.DEFAULT,
  };
}
